import { Button, MessageBar, MessageBarBody, MessageBarTitle, Spinner, Text } from '@fluentui/react-components';
import { createRootRouteWithContext, ErrorComponentProps, Outlet } from '@tanstack/react-router';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { router, RouterContext } from '../App';
import RootLayout from '../components/Layout/RootLayout';
import '../styles/root.css';

export const Route = createRootRouteWithContext<RouterContext>()({
  pendingComponent: () => (
    <RootLayout>
      <Spinner label={t('loading')} />
    </RootLayout>
  ),
  wrapInSuspense: true,
  beforeLoad: async (beforeLoadContextOptions) => {
    await beforeLoadContextOptions.context.licenseChecker.checkUserLicenseStatus();
  },
  component: RootRoute,
  errorComponent: RootErrorComponent,
});

function RootRoute() {
  return (
    <RootLayout>
      <Outlet />
    </RootLayout>
  );
}

function RootErrorComponent({ error, reset }: ErrorComponentProps) {
  const { t } = useTranslation();

  let title = t('rootErrorComponent.unknownError.title');
  let description = t('rootErrorComponent.unknownError.description');
  const isBackendOffline = error instanceof Error && error.message === 'Failed to fetch';
  if (isBackendOffline) {
    title = t('rootErrorComponent.backendOfflineError.title');
    description = t('rootErrorComponent.backendOfflineError.description');
  }

  return (
    <RootLayout>
      <MessageBar intent="error">
        <MessageBarBody style={{ padding: 'var(--spacingHorizontalM)' }}>
          <MessageBarTitle>{title}</MessageBarTitle>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Text>{description}</Text>
            <Button
              appearance="primary"
              onClick={() => {
                router.invalidate();
                reset();
              }}
            >
              {t('rootErrorComponent.retryButtonLabel')}
            </Button>
          </div>
        </MessageBarBody>
      </MessageBar>
    </RootLayout>
  );
}
